export default function anonymous(context
) {
var out=''+( context.stringFromRow(context.object.initialRow) )+( '\n' );var arr1=context.object.blocks;if(arr1){var course,i1=-1,l1=arr1.length-1;while(i1<l1){course=arr1[i1+=1];out+=''+( course.print('text', { end: '\n' }) );} } return out;
}